/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyCustomerLogs: LazyComponent<any> = lazyForPaint<any>(
	() =>
		import(
			/* webpackChunkName: "async-jira-eoc-customer-logs", jiraSpaEntry: "async-jira-eoc-customer-logs" */ '@jira/eoc__customer-logs/src/index.tsx'
		),
);

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyCustomerLogsDownLoad: LazyComponent<any> = lazyForPaint<any>(() =>
	import(
		/* webpackChunkName: "async-jira-eoc-customer-logs-download", jiraSpaEntry: "async-jira-eoc-customer-logs-download" */ '@jira/eoc__customer-logs/src/index.tsx'
	).then(({ CustomerLogsDownloadPage }) => CustomerLogsDownloadPage),
);

const AsyncCustomerLogsDownLoad = (): React.JSX.Element => (
	<LazyPage
		Page={LazyCustomerLogs}
		pageId="async-jira-eoc-customer-logs"
		shouldShowSpinner={false}
	/>
);

export default AsyncCustomerLogsDownLoad;

export const CustomerLogsDownloadPage = (): React.JSX.Element => (
	<LazyPage
		Page={LazyCustomerLogsDownLoad}
		pageId="async-jira-eoc-customer-logs-download"
		shouldShowSpinner={false}
	/>
);
